<template>
  <div class="metadata-area">
    <div class="outer-wrapper">
      <div class="inner-wrapper">

        <div v-if="brandLogo" class="brand-logo">
          <img :src="require(`@/assets/images/detail/logo_${brandLogo}.png`)" :alt="`${brandLogo} 로고`">
        </div>

        <h1 class="main-title">{{ movieTitle }}</h1>

        <div class="metadata">
          <ul class="metadata-list">
            <li v-if="metaData.year">{{ metaData.year }}</li>
            <li v-if="metaData.playTime">{{ metaData.playTime}}</li>
            <li v-if="metaData.targetAge"><AgeGrade :target-age="metaData.targetAge" :section="kmrbCode" /></li>
            <li v-if="metaData.genreText">{{ metaData.genreText }}</li>
          </ul>
          <ul class="tag-list">
            <li v-if="isSubTitle"><img :src="require('@/assets/images/detail/ico_badges_cc.png')" alt="cc 아이콘"></li>
            <li v-if="videoSpec"><img :src="require(`@/assets/images/detail/ico_badges_${videoSpec}.png`)" :alt="`${videoSpec} 아이콘`"></li>
          </ul>
        </div>

        <div class="comments">
          <ul>
            <template v-for="(comment, index) in comments">
              <li v-if="comment" :key="`comment_${index}`">{{ comment }}</li>
            </template>
          </ul>
        </div>

        <div v-if="!isPooqzone" class="optional-buttons">
          <IconBoxZzimWithApi section="movie" :content-id="contentId" :zzim="zzim"/>
          <IconBoxSnsShare :content-info="contentInfo" section="movie" />
        </div>

        <div class="essential-buttons">
          <label v-if="hasMovieGroup" class="selector">
            <select v-model="selectedMovie" @change="goToSelectedMovie">
              <option v-for="movie in movieGroup" :key="movie.value" :value="movie.value">
                {{ movie.text }}
              </option>
            </select>
          </label>

          <PlayerActionButton
            :click-player-fn="clickPlayerFn"
            :content-info="contentInfo"
            section="movie"
          />
        </div>

        <div class="summary">
          <div
            v-if="remainViewTime"
            class="history"
          >
            <div class="progress">
              <span class="progress-meter" :style="`width: ${viewRatio}`">&nbsp;</span>
            </div>
            <span>{{ remainViewTime }}분 남음</span>
          </div>

          <button
            type="button"
            class="btn-synopsis"
            @click.prevent="moveToDetailInfo()"
          >
            <v-clamp :max-lines="3" ellipsis="..." >
              {{ renderSynopsis(synopsis) }}
              <template #after>
                <span class="view-more">더보기</span>
              </template>
            </v-clamp>
          </button>
        </div>
      </div>
    </div>

    <div v-if="hasNoticeList || hasEventList" class="outer-wrapper">
      <div class="inner-wrapper">
        <div v-if="hasNoticeList" class="notice">
          <a
            v-for="(notice, index) in noticeList"
            href="javascript:void(0)"
            @click.prevent="noticePopupOpen(index)"
            :key="`notice_${index}`"
          >
            <span class="badge artwork ui">공지사항</span>
            <span>{{ notice.title }}</span>
          </a>
        </div>

        <div v-if="hasEventList" class="event">
          <a href="javascript:void(0)" @click.prevent="goEventPage(event.eventid)" :style="`background-color: ${event.bgcolor}`">
            <img :src="`https://${event.bannerimage}`" :alt="event.title">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { topTagList } from '@/common/directives'
import utils from '@/common/util/utils'
import IconBoxSnsShare from '@/components/play/IconBoxSnsShare'
import PlayerActionButton from '@/components/play/PlayerActionButton'
import IconBoxZzimWithApi from '@/components/play/IconBoxZzimWithApi'
import { get } from 'lodash'
import { PATH_NAME_PLAYER_MOVIE_DETAIL_INFO } from '@/common/router.const'
import AgeGrade from '@/components/play/AgeGrade'
import { getDecodedHTMLText, getRemainViewTime, getVideoSpec } from '@/common/util/player.util'
import VClamp from 'vue-clamp'

export default {
  name: 'MoviePlayerDetailInfo',
  components: {
    IconBoxZzimWithApi,
    IconBoxSnsShare,
    PlayerActionButton,
    AgeGrade,
    VClamp
  },
  directives: {
    topTagList
  },
  props: {
    contentInfo: {
      type: Object,
      default: () => {}
    },
    clickPlayerFn: {
      type: Function,
      default: null
    },
    noticeList: {
      type: Array,
      default: null
    },
    eventList: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      isPooqzone: utils.cookies.isPooqZone(),
      selectedMovie: get(this.$route, 'query.movieid', '')
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    brandLogo () {
      const wavveLogo = ['original', 'only']
      const brandLogo = get(this.contentInfo, 'brand_logolist.0', '')
      return wavveLogo.includes(brandLogo) ? `wavve_${brandLogo}` : brandLogo
    },
    contentId () {
      return get(this.contentInfo, 'movieid', '')
    },
    comments () {
      const { autocomment = '', comment = '' } = this.contentInfo
      return [ autocomment, comment ]
    },
    event () {
      const banner = get(this.eventList, '0', {})
      const { bannerimage = '', bgcolor = '', eventtitle = '', eventid = '' } = banner
      return { bannerimage, bgcolor, eventtitle, eventid }
    },
    kmrbCode () {
      const { kmrbcode = '' } = this.contentInfo
      return kmrbcode ? 'movie' : 'vod'
    },
    metaData () {
      const { originalreleaseyear = '', genre = {}, playtime = '0', targetage = '' } = this.contentInfo
      const year = originalreleaseyear
      const playTime = `${Math.floor(Number(playtime) / 60)}분`
      const targetAge = targetage
      const genreText = get(genre, 'list.0.text', '')

      return { year, playTime, targetAge, genreText }
    },
    movieGroup () {
      return get(this.contentInfo, 'moviegroup.list', [])
    },
    movieTitle () {
      return get(this.contentInfo, 'title', '')
    },
    remainViewTime () {
      const { viewtime = '0', playtime = '0' } = this.contentInfo
      const hasViewTime = (Number(viewtime) > 0)
      return hasViewTime ? getRemainViewTime(playtime, viewtime) : 0
    },
    synopsis () {
      return get(this.contentInfo, 'synopsis', '')
    },
    videoSpec () {
      return getVideoSpec(this.contentInfo)
    },
    viewRatio () {
      return `${Number(get(this.contentInfo, 'viewratio', '')) * 100}%`
    },
    zzim () {
      return get(this.contentInfo, 'zzim', 'n').toLowerCase()
    },
    isSubTitle () {
      return get(this.contentInfo, 'issubtitle', '').toLowerCase() === 'y'
    },
    hasEventList () {
      return this.eventList.length > 0
    },
    hasMovieGroup () {
      return this.movieGroup.length > 1 && !get(this.contentInfo, 'originalmovieid', '')
    },
    hasNoticeList () {
      return (this.noticeList || []).length > 0
    }
  },
  methods: {
    moveToDetailInfo () {
      this.$router.push({
        name: PATH_NAME_PLAYER_MOVIE_DETAIL_INFO,
        query: {
          movieid: get(this.$route, 'query.movieid', '')
        }
      })
    },
    goToSelectedMovie () {
      this.$router.replace(`/player/movie?movieid=${this.selectedMovie}`)
    },
    noticePopupOpen (noticeIndex) {
      const { query = {} } = this.$route
      const { movieid: movieId = '' } = query

      this.$router.push(`/player/movie?movieid=${movieId}&isNotice=y&noticeIdx=${noticeIndex}`)
    },
    renderSynopsis (synopsis) {
      return getDecodedHTMLText(synopsis)
    },
    goEventPage (eventId) {
      this.$router.push(`/event/detail/${eventId}`)
    }
  },
  watch: {
    selected (newVal, oldVal) {
      const getMovieGroupItemByValue = (value) => {
        return get(this.contentInfo, 'moviegroup.list', []).filter((item, index) => {
          return item.text === value
        })[0]
      }
      if (newVal !== oldVal) {
        const newMovieGroupItem = getMovieGroupItemByValue(newVal)
        this.$router.push('/player/movie?movieid=' + get(newMovieGroupItem, 'value', ''))
      }
    }
  }
}
</script>
